// extracted by mini-css-extract-plugin
export default {"mobileHeader":"HlQjZi9Lr6HyDRvyZVFA","titleBox":"boayg_higuwPZ2m3MYgl"};